import { Link } from 'react-router-dom'
import { number, sol } from '../utils'

export function MarketLaunchCard({ launch }: { launch: any }) {
  const launchId = String(launch?.id || launch?.launch_id || launch?.launchId || '')
  const name = String(launch?.name || launch?.collection_name || launch?.headline || 'OnlyRose launch')
  const image = String(launch?.image_url || launch?.banner_url || launch?.logo_url || '')
  const phase = String(launch?.phase || launch?.status || 'launch').toUpperCase()
  const minted = Number(launch?.minted_count || 0)
  const supply = Number(launch?.supply || 0)
  const price = Number(launch?.mint_price_lamports || 0)

  const body = <>
    <div className="market-launch-media">
      {image ? <img src={image} alt={name} loading="lazy" decoding="async" referrerPolicy="no-referrer"/> : <span>{name.slice(0,1)}</span>}
      <span>{phase}</span>
    </div>
    <div className="market-launch-body">
      <h3>{name}</h3>
      <div className="market-launch-stats">
        <span>{supply > 0 ? `${number(minted)} / ${number(supply)} minted` : `${number(minted)} minted`}</span>
        <b>{price > 0 ? sol(price) : 'Mint price —'}</b>
      </div>
    </div>
  </>

  return launchId
    ? <Link className="market-launch-card" to={`/launchpad/${encodeURIComponent(launchId)}`}>{body}</Link>
    : <Link className="market-launch-card" to="/launchpad">{body}</Link>
}
